import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";
const MEDIA = "https://live-evo.com";

function StaffVideoPendingPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadVideos = async () => {
    try {
      const res = await staffFetch(`${API}/staff/video-pending`);
      const data = await res.json();

      setVideos(data.videos || []);
    } catch (err) {
      console.log("Erreur loadVideos pending:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadVideos();
  }, []);

  const getVideoUrl = (filePath) => {
    if (!filePath) return "";

    if (filePath.startsWith("http")) {
      return filePath;
    }

    if (filePath.startsWith("/")) {
      return `${MEDIA}${filePath}`;
    }

    return `${MEDIA}/uploads/${filePath}`;
  };

  const approveVideo = async (id) => {
    try {
      await staffFetch(`${API}/staff/video-pending/${id}/approve`, {
        method: "PUT"
      });

      alert("Vidéo validée");

      loadVideos();
    } catch {
      alert("Impossible de valider");
    }
  };

  const rejectVideo = async (id) => {
    const ok = window.confirm(
      "Refuser cette vidéo ?"
    );

    if (!ok) return;

    try {
      await staffFetch(`${API}/staff/video-pending/${id}/reject`, {
        method: "PUT"
      });

      alert("Vidéo refusée");

      loadVideos();
    } catch {
      alert("Impossible de refuser");
    }
  };

  if (loading) {
    return (
      <div style={center}>
        Chargement...
      </div>
    );
  }

  return (
    <div style={container}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <button
          style={backBtn}
          onClick={() => {
            window.location.href = "/staff";
          }}
        >
          ← Retour staff
        </button>

        {videos.length === 0 ? (
          <div style={empty}>
            Aucune vidéo en attente.
          </div>
        ) : (
          videos.map((item) => {
            const videoUrl = getVideoUrl(item.file_path);

            return (
              <div
                key={item.id}
                style={card}
              >
                <div style={title}>
                  📂 Vidéo en attente #{item.id}
                </div>

                <div style={label}>
                  Auteur :
                </div>

                <div style={value}>
                  {item.pseudo || "Pseudo inconnu"}
                  {" "}
                  (
                  {item.user_email}
                  )
                </div>

                <div style={label}>
                  Description :
                </div>

                <div style={value}>
                  {item.description || "Aucune description"}
                </div>

                <div style={label}>
                  Statut :
                </div>

                <div style={status}>
                  {item.status}
                </div>

                {videoUrl ? (
                  <video
                    src={videoUrl}
                    controls
                    style={video}
                  />
                ) : (
                  <div style={errorText}>
                    Aucun fichier vidéo
                  </div>
                )}

                <div style={buttons}>
                  <button
                    style={btnApprove}
                    onClick={() => approveVideo(item.id)}
                  >
                    Valider
                  </button>

                  <button
                    style={btnReject}
                    onClick={() => rejectVideo(item.id)}
                  >
                    Refuser
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

const container = {
  minHeight: "100vh",
  background: "#05070d",
  padding: 14,
  color: "#fff"
};

const backBtn = {
  background: "#020b14",
  border: "1px solid #00f2ff",
  padding: 10,
  borderRadius: 10,
  marginBottom: 10,
  color: "#00f2ff",
  fontWeight: "bold",
  width: "100%",
  cursor: "pointer"
};

const card = {
  background: "#0d111a",
  border: "1px solid #00f2ff",
  borderRadius: 12,
  padding: 14,
  marginBottom: 14
};

const title = {
  color: "#00f2ff",
  fontWeight: "bold",
  fontSize: 16,
  marginBottom: 8
};

const label = {
  color: "#8fa6ad",
  marginTop: 5
};

const value = {
  color: "#fff"
};

const status = {
  color: "#00f2ff",
  fontWeight: "bold"
};

const video = {
  width: "100%",
  maxHeight: "650px",
  background: "#000",
  marginTop: 12,
  borderRadius: 10
};

const buttons = {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  marginTop: 14
};

const btnApprove = {
  background: "#00f2ff",
  padding: 12,
  borderRadius: 8,
  border: "none",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer"
};

const btnReject = {
  background: "#ff2d55",
  padding: 12,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

const empty = {
  color: "#8fa6ad",
  textAlign: "center",
  marginTop: 30
};

const errorText = {
  color: "#ff2d55",
  marginTop: 10
};

const center = {
  minHeight: "100vh",
  background: "#05070d",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#00f2ff"
};

export default StaffVideoPendingPage;
